export const PRIVACY_AND_COOKIES_URLS = {
  en: 'https://layerscrop.com/en/privacy-and-cookies-policy/',
  es: 'https://layerscrop.com/politica-privacidad-y-cookies/',
  pt: 'https://layerscrop.com/pt-br/politica-de-privacidade-e-cookies/'
}

export const getPrivacyAndCookiesUrlByLocale = locale => PRIVACY_AND_COOKIES_URLS[locale] || PRIVACY_AND_COOKIES_URLS.en
